import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home.vue";
import ProcessTicket from "./views/Ticket/ProcessTicket.vue";
import TicketDashboard from "./views/Ticket/Dashboard.vue";
import ArticleDashboard from "./views/Article/ArticleDashboard.vue";
import AccountingDashboard from "./views/Accounting/AccountingDashboard.vue";
import AssemblyView from "./views/Article/AssemblyView.vue";
import store from "./store/store";
Vue.use(Router);

const router = new Router({
	routes: [
		{
			path: "/",
			name: "home",
			component: Home,
		},
		{
			path: "/ticket",
			name: "ticket",
			props: true,
			// route level code-splitting
			// this generates a separate chunk (about.[hash].js) for this route
			// which is lazy-loaded when the route is visited.
			component: TicketDashboard,
		},
		{
			path: "/ticket/process/:ticketId/:embedded?",
			name: "processTicket",
			props: true,
			// route level code-splitting
			// this generates a separate chunk (about.[hash].js) for this route
			// which is lazy-loaded when the route is visited.
			component: ProcessTicket,
		},
		{
			path: "/customer",
			name: "customer",
			// route level code-splitting
			// this generates a separate chunk (about.[hash].js) for this route
			// which is lazy-loaded when the route is visited.
			component: () =>
				import(/* webpackChunkName: "about" */ "./views/Customer/Dashboard.vue"),
		},
		{
			path: "/order/:articleId?",
			name: "order",
			props: true,
			// route level code-splitting
			// this generates a separate chunk (about.[hash].js) for this route
			// which is lazy-loaded when the route is visited.
			component: () => import(/* webpackChunkName: "about" */ "./views/Orders/Dashboard.vue"),
		},
		{
			path: "/offers",
			name: "offers",
			props: false,
			component: () => import(/* webpackChunkName: "about" */ "./views/Offers/Dashboard.vue"),
		},
		{
			path: "/order/edit/:orderId",
			name: "editOrder",
			props: true,
			// route level code-splitting
			// this generates a separate chunk (about.[hash].js) for this route
			// which is lazy-loaded when the route is visited.
			component: () => import(/* webpackChunkName: "about" */ "./views/Orders/EditOrder.vue"),
		},
		{
			path: "/order/create/:customerId",
			name: "createOrder",
			props: true,
			// route level code-splitting
			// this generates a separate chunk (about.[hash].js) for this route
			// which is lazy-loaded when the route is visited.
			component: () =>
				import(/* webpackChunkName: "about" */ "./views/Orders/QuickOrder.vue"),
		},
		{
			path: "/cancellationRequest/:orderId",
			name: "cancellationRequest",
			props: true,
			// route level code-splitting
			// this generates a separate chunk (about.[hash].js) for this route
			// which is lazy-loaded when the route is visited.
			component: () =>
				import(
					/* webpackChunkName: "about" */ "./views/Orders/EditCancellationRequest.vue"
				),
		},
		{
			path: "/report",
			name: "report",
			props: true,
			// route level code-splitting
			// this generates a separate chunk (about.[hash].js) for this route
			// which is lazy-loaded when the route is visited.
			component: () =>
				import(/* webpackChunkName: "about" */ "./views/Reporting/Reports.vue"),
		},
		{
			path: "/marketing/adCampaigns",
			name: "adCampaigns",
			props: false,
			// route level code-splitting
			// this generates a separate chunk (about.[hash].js) for this route
			// which is lazy-loaded when the route is visited.
			component: () =>
				import(/* webpackChunkName: "about" */ "./views/Marketing/AdCampaigns.vue"),
		},
		{
			path: "/marketing/marketingStatistics",
			name: "marketingStatistics",
			props: false,
			// route level code-splitting
			// this generates a separate chunk (about.[hash].js) for this route
			// which is lazy-loaded when the route is visited.
			component: () =>
				import(/* webpackChunkName: "about" */ "./views/Marketing/MarketingStatistics.vue"),
		},
		{
			path: "/report/complainrate",
			name: "reportComplainRate",
			props: true,
			// route level code-splitting
			// this generates a separate chunk (about.[hash].js) for this route
			// which is lazy-loaded when the route is visited.
			component: () =>
				import(/* webpackChunkName: "about" */ "./views/Reporting/ComplainRate.vue"),
		},
		{
			path: "/report/registration",
			name: "registration",
			props: true,
			// route level code-splitting
			// this generates a separate chunk (about.[hash].js) for this route
			// which is lazy-loaded when the route is visited.
			component: () =>
				import(/* webpackChunkName: "about" */ "./views/Reporting/Registration.vue"),
		},
		{
			path: "/report/deliveryDelay",
			name: "deliveryDelay",
			props: true,
			// route level code-splitting
			// this generates a separate chunk (about.[hash].js) for this route
			// which is lazy-loaded when the route is visited.
			component: () =>
				import(/* webpackChunkName: "about" */ "./views/Reporting/DeliveryDelay.vue"),
		},
		{
			path: "/report/costDistribution",
			name: "costDistribution",
			props: true,
			// route level code-splitting
			// this generates a separate chunk (about.[hash].js) for this route
			// which is lazy-loaded when the route is visited.
			component: () =>
				import(/* webpackChunkName: "about" */ "./views/Reporting/CostDistribution.vue"),
		},
		{
			path: "/report/orderVolume",
			name: "orderVolume",
			props: true,
			component: () =>
				import(
					/* webpackChunkName: "about" */ "./views/Reporting/OrderVolumePerTechnology.vue"
				),
		},
		{
			path: "/report/uploadedArticles",
			name: "uploadedArticles",
			props: true,
			component: () =>
				import(/* webpackChunkName: "about" */ "./views/Reporting/UploadedArticles.vue"),
		},
		{
			path: "/report/orderVolumePerManufacturer",
			name: "orderVolumePerManufacturer",
			props: true,
			component: () =>
				import(
					/* webpackChunkName: "about" */ "./views/Reporting/OrderVolumePerManufacturerReport.vue"
				),
		},
		{
			path: "/report/orderedMaterials",
			name: "orderedMaterials",
			props: true,
			component: () =>
				import(/* webpackChunkName: "about" */ "./views/Reporting/OrderedMaterials.vue"),
		},
		{
			path: "/report/transportCost",
			name: "transportCostReport",
			props: true,
			component: () =>
				import(/* webpackChunkName: "about" */ "./views/Reporting/TransportCost.vue"),
		},
		{
			path: "/article",
			name: "article",
			props: true,
			// route level code-splitting
			// this generates a separate chunk (about.[hash].js) for this route
			// which is lazy-loaded when the route is visited.
			component: ArticleDashboard,
		},
		{
			path: "/article/assembly/:assemblyArticleId",
			name: "assemblyView",
			props: true,
			component: AssemblyView,
		},
		{
			path: "/customer/detail/:customerId",
			name: "customerDetail",
			props: true,
			// route level code-splitting
			// this generates a separate chunk (about.[hash].js) for this route
			// which is lazy-loaded when the route is visited.
			component: () => import(/* webpackChunkName: "about" */ "./views/Customer/Detail.vue"),
		},
		{
			path: "/customer/settlement/:customerId",
			name: "customerSettlement",
			props: true,
			// route level code-splitting
			// this generates a separate chunk (about.[hash].js) for this route
			// which is lazy-loaded when the route is visited.
			component: () =>
				import(/* webpackChunkName: "about" */ "./views/Customer/Settlement.vue"),
		},
		{
			path: "/customer/calculations",
			name: "customerCalculations",
			props: true,
			// route level code-splitting
			// this generates a separate chunk (about.[hash].js) for this route
			// which is lazy-loaded when the route is visited.
			component: () =>
				import(/* webpackChunkName: "about" */ "./views/Customer/Calculations.vue"),
		},
		{
			path: "/manufacturerSettlement",
			name: "manufacturerSettlement",
			// route level code-splitting
			// this generates a separate chunk (about.[hash].js) for this route
			// which is lazy-loaded when the route is visited.
			component: () =>
				import(
					/* webpackChunkName: "about" */ "./views/ManufacturerSettlement/Dashboard.vue"
				),
		},
		{
			path: "/accounting",
			name: "accounting",
			// route level code-splitting
			// this generates a separate chunk (about.[hash].js) for this route
			// which is lazy-loaded when the route is visited.
			component: AccountingDashboard,
		},
		{
			path: "/accounting/paper-invoices",
			name: "paperInvoices",
			component: () => import("./views/Accounting/PaperInvoicesView.vue"),
		},
		{
			path: "/accounting/turnover",
			name: "turnover",
			component: () => import("./views/Accounting/TurnoverView.vue"),
		},
		{
			path: "/accounting/mwst-abrechnung",
			name: "mwstAbrechnung",
			component: () => import("./views/Accounting/MwstAbrechnungView.vue"),
		},
		{
			path: "/accounting/creditNotes",
			name: "creditNotes",
			component: () => import("./views/Accounting/CreditNotes.vue"),
		},
		{
			path: "/editInvoice/:invoiceId",
			name: "editInvoice",
			props: true,
			// route level code-splitting
			// this generates a separate chunk (about.[hash].js) for this route
			// which is lazy-loaded when the route is visited.
			component: () => import("./views/Accounting/EditInvoice.vue"),
		},
		{
			path: "/settings",
			name: "settings",
			// route level code-splitting
			// this generates a separate chunk (about.[hash].js) for this route
			// which is lazy-loaded when the route is visited.
			component: () =>
				import(/* webpackChunkName: "about" */ "./views/Settings/Settings.vue"),
		},
		{
			path: "/settings/materialprices",
			name: "materialprices",
			// route level code-splitting
			// this generates a separate chunk (about.[hash].js) for this route
			// which is lazy-loaded when the route is visited.
			component: () =>
				import(/* webpackChunkName: "about" */ "./views/Settings/MaterialPrices.vue"),
		},
		{
			path: "/settings/materialSettings",
			name: "materialSettings",
			// route level code-splitting
			// this generates a separate chunk (about.[hash].js) for this route
			// which is lazy-loaded when the route is visited.
			component: () =>
				import(/* webpackChunkName: "about" */ "./views/Settings/MaterialSettings.vue"),
		},
		{
			path: "/settings/camMessageSettings",
			name: "camMessageSettings",
			// route level code-splitting
			// this generates a separate chunk (about.[hash].js) for this route
			// which is lazy-loaded when the route is visited.
			component: () =>
				import(/* webpackChunkName: "about" */ "./views/Settings/CamMessageSettings.vue"),
		},
		{
			path: "/settings/formTemplateSettings",
			name: "formTemplateSettings",
			// route level code-splitting
			// this generates a separate chunk (about.[hash].js) for this route
			// which is lazy-loaded when the route is visited.
			component: () =>
				import(/* webpackChunkName: "about" */ "./views/Settings/FormTemplateSettings.vue"),
		},
		{
			path: "/settings/calcSettings",
			name: "calcSettings",
			// route level code-splitting
			// this generates a separate chunk (about.[hash].js) for this route
			// which is lazy-loaded when the route is visited.
			component: () =>
				import(/* webpackChunkName: "about" */ "./views/Settings/CalcSettings.vue"),
		},
		{
			path: "/settings/globalSettings",
			name: "globalSettings",
			// route level code-splitting
			// this generates a separate chunk (about.[hash].js) for this route
			// which is lazy-loaded when the route is visited.
			component: () =>
				import(/* webpackChunkName: "about" */ "./views/Settings/GlobalSettings.vue"),
		},
		{
			path: "/settings/werkstoffe",
			name: "werkstoffe",
			// route level code-splitting
			// this generates a separate chunk (about.[hash].js) for this route
			// which is lazy-loaded when the route is visited.
			component: () =>
				import(/* webpackChunkName: "about" */ "./views/Settings/Werkstoffe.vue"),
		},
		{
			path: "/settings/pressJoinSettings",
			name: "pressJoinSettings",
			// route level code-splitting
			// this generates a separate chunk (about.[hash].js) for this route
			// which is lazy-loaded when the route is visited.
			component: () =>
				import(/* webpackChunkName: "about" */ "./views/Settings/PressJoinSettings.vue"),
		},
		{
			path: "/settings/pressJoinSettings/material/:toolId/:description",
			name: "pressJoinMaterialSettings",
			props: true,
			// route level code-splitting
			// this generates a separate chunk (about.[hash].js) for this route
			// which is lazy-loaded when the route is visited.
			component: () =>
				import(
					/* webpackChunkName: "about" */ "./views/Settings/PressJoinMaterialSettings.vue"
				),
		},
		{
			path: "/settings/monitoring",
			name: "monitoring",
			// route level code-splitting
			// this generates a separate chunk (about.[hash].js) for this route
			// which is lazy-loaded when the route is visited.
			component: () =>
				import(/* webpackChunkName: "about" */ "./views/Settings/CamMonitor.vue"),
		},
		{
			path: "/log",
			name: "log",
			// route level code-splitting
			// this generates a separate chunk (about.[hash].js) for this route
			// which is lazy-loaded when the route is visited.
			component: () => import(/* webpackChunkName: "about" */ "./views/Log.vue"),
		},
	],
});
router.beforeEach((to: any, from: any, next) => {
	if (to.path.includes("ticket") || store.state.isAdmin) {
		next();
	} else {
		next(false);
	}
});
export default router;
